module.exports = __webpack_public_path__ + "database-technology.UAKa_04o.svg";